import { useState, useEffect, useRef } from "react"
import nodeApiService from "../../services/nodeApiService"
import styles from "../../features/pages/ArtworkDetailPage/ArtworkDetailPage.module.css"
import { getArtworkSize } from "../../services/utils/getArtworkSize"

export const useArtworkPurchaseActions = (artwork, insertArplacerButtons) => {
  const recaptchaRefPurchase = useRef()
  const [formPurchase, setFormPurchase] = useState({
    email: "",
    firstname: "",
    lastname: "",
    phone: "",
    shipping: {
      street: "",
      city: "",
      state: "",
      country: "",
      zip: "",
    },
    body: "",
  })
  const [modalPurchase, setModalPurchase] = useState(false)
  const [errorPurchase, setErrorPurchase] = useState(false)
  const [errorMessagePurchase, setErrorMessagePurchase] = useState([])
  const [sizePurchase, setSizePurchase] = useState(null)
  const [successPurchase, setSuccessPurchase] = useState(false)

  const handleClosePurchase = () => {
    setModalPurchase(false)
    setTimeout(() => {
      setSuccessPurchase(false)
    }, 500)
  }
  const handleShowPurchase = () => {
    setSuccessPurchase(false)
    setModalPurchase(true)
  }
  const onSubmitPurchase = (event) => {
    event.preventDefault()
    recaptchaRefPurchase.current.execute()
  }
  const successCallback = () => {
    setSuccessPurchase(true)
    setFormPurchase({
      email: "",
      firstname: "",
      lastname: "",
      phone: "",
      shipping: {
        street: "",
        city: "",
        state: "",
        country: "",
        zip: "",
      },
      body: "",
    })
  }
  const onReCAPTCHAChangePurchase = async (captchaCode) => {
    if (!captchaCode) {
      return
    }
    setErrorPurchase(false)
    nodeApiService
      .purchase(artwork.id, {
        ...formPurchase,
        captcha: captchaCode,
        channel: "discover",
        type: "purchase_discover",
      })
      .then(
        (_) => {
          successCallback()
        },
        (res) => {
          setErrorPurchase(true)
          setErrorMessagePurchase(res.response.data.errorMessage)
        },
      )
    recaptchaRefPurchase.current.reset()
  }

  useEffect(() => {
    setSizePurchase(getArtworkSize(artwork.width, artwork.height))
    insertArplacerButtons ? insertArplacerButtons() : null
  }, [artwork])

  return {
    formPurchase,
    setFormPurchase,
    modalPurchase,
    handleClosePurchase,
    handleShowPurchase,
    onSubmitPurchase,
    errorPurchase,
    errorMessagePurchase,
    successPurchase,
    sizePurchase,
    onReCAPTCHAChangePurchase,
    recaptchaRefPurchase,
  }
}
